import { LitElement, html, svg } from 'lit';

export class IconNettbil42 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="42" height="28" fill="none" viewBox="0 0 42 28"><title>To sirkler med en halvsirkel over</title><path fill="#004046" d="M2.837 22.053a6.639 6.639 0 0 1 9.387-9.386 6.639 6.639 0 0 1-9.387 9.386ZM29.545 22.053a6.639 6.639 0 0 1 9.387-9.386 6.638 6.638 0 0 1-9.387 9.386Z"></path><path fill="#FF8752" d="M34.24 17.36C34.24 9.995 28.25 4 20.884 4c-7.366 0-13.36 5.995-13.36 13.36h26.714Z"></path></svg>`; }
}
if (!customElements.get('f-icon-nettbil42', IconNettbil42)) {
  customElements.define('f-icon-nettbil42', IconNettbil42);
}